import { forwardRef, useRef } from "react";
import { TCaseTip } from "../../../../../../../services/api/instances/casesApi/types";
import { AppTooltip } from "../../../../../../../shared/components/AppTooltip";
import styles from "./styles.module.css";

interface Props {
  tips: TCaseTip[];
  handleClickTip: (value: string) => void;
  className?: string;
}

export const CaseTipBlock = forwardRef<HTMLUListElement, Props>(
  ({ tips, handleClickTip }, ref) => {
    const divRef = useRef<HTMLDivElement | null>(null);
    return (
      <ul ref={ref} className={styles["case-tip-menu"]}>
        {tips.map((tip, index) => (
          <li key={index} className={styles["tip-item"]}>
            <AppTooltip title={tip.reason} placement="right">
              <div ref={divRef} onClick={() => handleClickTip(tip.formulation)}>
                {tip.formulation}
              </div>
            </AppTooltip>
          </li>
        ))}
      </ul>
    );
  },
);
